module.exports = __webpack_public_path__ + "assets/icons/manager-logo.d2ac0a2990672d39819968449d55c4f1.svg";